const CookieBannerSelector = '#CybotCookiebotDialog'
/*
  Fix for autohide of the cookie banner
*/
function waitForElement(selector) {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(mutations => {
      if (document.querySelector(selector)) {
          resolve(document.querySelector(selector));
          observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

function getCookie (name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

function checkCookieBanner () {
  const val = getCookie('CookieConsent')
  
  // customer agreed
  if (!val) {
    return false
  }

  if (val.includes('explicit')) {
    return true
  }

  // we need to display cookie banner

  if ($(CookieBannerSelector).css('display') === 'none') {
    $(CookieBannerSelector).show()
    $(CookieBannerSelector).css('opacity', '1')
  }
  return false
}

async function cookieBanner () {
  const val = getCookie('CookieConsent')
  if (!!val && val.includes('explicit')) {
    console.log('NO NEED')
    // accepted by user, dont do anything
    return
  }

  await waitForElement('script[src="https://consentcdn.cookiebot.com/consentconfig/0dd0daa2-9e3f-4edf-993e-5b8d1b44989c/state.js"]')
  if (!!val && val.includes('implied')) {
    console.log('IMPLIED')
    Cookiebot.show()
  }

  await waitForElement(CookieBannerSelector)
  console.log('ELEMENT HERE')
  let int = setInterval(() => {
    const res = checkCookieBanner()

    if (res === true) {
      clearInterval(int)
      console.log('CLEAR INT')
    }
  }, 111)
}

cookieBanner()